export const textConstants = {
  siteTitle: 'Dixa Accounts',
  siteTitleWithDivider: '| Dixa Accounts',
};
